import React from "react";
import { Icon } from "../../UIElements/Icon";
import { Button } from "../../UIElements/Button";
import { useTranslation } from "react-i18next";

const OrdersError = ({ error, onRetry }) => {
  const { t } = useTranslation("orders");

  return (
    <div className="border-error/40 bg-error-bg rounded-lg border p-6">
      <div className="flex items-center space-x-3">
        <div className="text-error">
          <Icon name="AlertTriangle" className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="text-error text-lg font-medium">
            {t("errors.loadTitle")}
          </h3>
          <p className="text-error mt-1 text-sm">
            {error?.message || t("errors.loadDescription")}
          </p>
        </div>
        {onRetry && (
          <Button
            variant="ghost"
            onClick={onRetry}
            className="bg-error hover:bg-error/90 rounded-lg px-4 py-2 text-sm font-medium text-[var(--error-foreground)] transition-colors"
          >
            {t("errors.retry")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default OrdersError;
